import { BookOpen, Search, PenTool, Shuffle, ShieldCheck, CheckCircle2 } from 'lucide-react';
import type { fr } from '../i18n/fr';

export type TranslationKeys = typeof fr;

/** Maps agent name → pipeline step index (0-based) */
export const AGENT_STEP: Record<string, number> = {
  orchestrator: 0,
  memory: 0,
  knowledge: 1,
  writer: 2,
  diversity: 3,
  compliance: 4,
  positioning: 4,
  critic: 5,
  finalize: 5,
  system: 5,
};

/** Alternate purple/green palette for the 6 steps */
const STEP_COLORS = [
  'var(--color-primary)', // 0 — Mémoire
  '#3EFFC0',             // 1 — Recherche
  'var(--color-primary)', // 2 — Rédaction
  '#3EFFC0',             // 3 — Variété
  'var(--color-primary)', // 4 — Charte
  '#3EFFC0',             // 5 — Validation
] as const;

const STEP_ICONS = [BookOpen, Search, PenTool, Shuffle, ShieldCheck, CheckCircle2] as const;

export interface PipelineStep {
  label: string;
  tooltip: string;
  color: string;
  Icon: (typeof STEP_ICONS)[number];
}

/**
 * Returns the 6 pipeline steps with labels and tooltips from the active locale.
 * Call this inside a component that has access to `t` from `useLanguage()`.
 */
export function getPipelineSteps(t: TranslationKeys): PipelineStep[] {
  const p = t.generate.pipeline;
  return [
    { label: p.memory.label,     tooltip: p.memory.tooltip,     color: STEP_COLORS[0], Icon: STEP_ICONS[0] },
    { label: p.knowledge.label,  tooltip: p.knowledge.tooltip,  color: STEP_COLORS[1], Icon: STEP_ICONS[1] },
    { label: p.writer.label,     tooltip: p.writer.tooltip,     color: STEP_COLORS[2], Icon: STEP_ICONS[2] },
    { label: p.diversity.label,  tooltip: p.diversity.tooltip,  color: STEP_COLORS[3], Icon: STEP_ICONS[3] },
    { label: p.compliance.label, tooltip: p.compliance.tooltip, color: STEP_COLORS[4], Icon: STEP_ICONS[4] },
    { label: p.finalize.label,   tooltip: p.finalize.tooltip,   color: STEP_COLORS[5], Icon: STEP_ICONS[5] },
  ];
}
